var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { Route } from 'vue-router';
import { isEqual } from 'lodash';
let SubjectLabelFilter = class SubjectLabelFilter extends Vue {
    mounted() {
        this.onMounted();
    }
    async onMounted() {
        const routeValue = getValueFromRoute(this.$route);
        if (routeValue.length && !isEqual(this.value, routeValue)) {
            this.$emit('input', routeValue);
        }
        this.$nextTick(() => {
            this.preFillSelects();
        });
    }
    async onInput(value) {
        if (isEqual(this.value, value)) {
            return;
        }
        this.$emit('input', value);
    }
    preFillSelects() {
        if (!this.value || !this.$refs.select) {
            return;
        }
        this.$refs.select.setSelected(this.value || []);
    }
    routeChanged(newRoute, oldRoute) {
        const newValue = getValueFromRoute(newRoute);
        const oldValue = getValueFromRoute(oldRoute);
        if (isEqual(newValue, oldValue)) {
            return;
        }
        if (isEqual(this.value, newValue)) {
            return;
        }
        this.$emit('input', newValue);
        this.$nextTick(() => {
            this.preFillSelects();
        });
    }
};
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], SubjectLabelFilter.prototype, "value", void 0);
__decorate([
    Watch('$route', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_a = typeof Route !== "undefined" && Route) === "function" ? _a : Object, typeof (_b = typeof Route !== "undefined" && Route) === "function" ? _b : Object]),
    __metadata("design:returntype", void 0)
], SubjectLabelFilter.prototype, "routeChanged", null);
SubjectLabelFilter = __decorate([
    Component({
        components: {
            SelectFilter,
        },
    })
], SubjectLabelFilter);
export default SubjectLabelFilter;
const getValueFromRoute = (route) => route.query && route.query.subjectLabels ? (Array.isArray(route.query.subjectLabels) ? route.query.subjectLabels : [route.query.subjectLabels]) : [];
